// src/components/DynamicReportInputs/ProgramRsSmSelector.js
import React from "react";
import GenericSelector from "./GenericSelector";

export const PROGRAM_RS_SM_OPTIONS = [
  { value: 1, label: "Receta Solidaria" },
  { value: 2, label: "Solo Mujer" },
];

export default function ProgramRsSmSelector({
  value,
  onChange,
  error = null,
  required = false,
  label = "Programa",
}) {
  return (
    <GenericSelector
      label={label}
      value={value}
      onChange={onChange}
      options={PROGRAM_RS_SM_OPTIONS}
      error={error}
      required={required}
    />
  );
}
